import { RouteLink } from 'routes';
import { shape, string } from 'prop-types';
import ListSubmenu from './ListSubmenu';
import { ListItemButton, ListItemText } from 'components/mui';
import { APP_CAN_APPS_V3 } from 'constants/appNames';
import styles from '../styles/cantab.module.css';
import { getCanTabState, setCanTabState } from '../libs/useLocalStorage';

/**
 * @component ListMenu
 * @param { Object } props
 * @param { object } props.tab
 * @returns { JSX.Element }
 */
function ListMenu({ tab, open, setMenuClose, activeTab }) {
	const onClickTab = () => {
		const canTabSettings = getCanTabState();
		canTabSettings.menuState = 'closed';
		setCanTabState(canTabSettings);
	};
	return tab.url !== 'Sub-menu' ? (
		tab.type === APP_CAN_APPS_V3 ? (
			<ListItemButton
				data-tour={
					tab.url?.includes('canpark-admin')
						? 'manage-sites-menu-item'
						: tab.url?.includes('users')
							? 'users-menu-item'
							: undefined
				}
				className={`${styles.lm_list_btn}
					${activeTab === `/${APP_CAN_APPS_V3}${tab.url}` ? styles.active_tab : ''}`}
				component={RouteLink}
				to={tab.url}
				onClick={() => {
					onClickTab();
					setMenuClose();
				}}
			>
				<ListItemText
					className={styles.lm_list_text}
					primary={tab.name}
				/>
			</ListItemButton>
		) : (
			<ListItemButton
				data-tour={tab.url?.includes('users') ? 'users-menu-item' : undefined}
				className={styles.lm_list_btn}
				component="a"
				href={tab.url}
				onClick={onClickTab}
			>
				<ListItemText
					className={styles.lm_list_text}
					primary={tab.name}
				/>
			</ListItemButton>
		)
	) : (
		<ListSubmenu
			tab={tab}
			menuOpen={open}
			setMenuClose={setMenuClose}
			activeTab={activeTab}
		/>
	);
}

ListMenu.propTypes = {
	tab: shape({ id: string, name: string, url: string, type: string }),
};

export default ListMenu;
